import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { FC, ReactNode, useCallback, useMemo, useState } from 'react';
import {
  render,
  StoryblokRichtext,
} from 'storyblok-rich-text-react-renderer-ts';

import {
  countStoryblokRichTextChars,
  truncateStoryblokRichText,
} from '../../../utils/renderStoryblokRichText';
import { RichTextLink } from '../../RichTextLink';

type Props = {
  className?: string;
  charCount: number;
  onClick?: () => void;
  text: StoryblokRichtext;
};

const paragraph = (children: ReactNode) => (
  <p className="pb-3 last-of-type:inline last-of-type:pb-0">{children}</p>
);

export const ExpandableRichText: FC<Props> = ({
  charCount,
  className = '',
  onClick,
  text,
}) => {
  const { t } = useTranslation('common');

  const [expanded, setExpanded] = useState(
    countStoryblokRichTextChars(text) <= charCount,
  );

  const handleExpand = useCallback(() => {
    setExpanded(true);
    onClick?.();
  }, [onClick]);

  const truncatedText = useMemo(
    () => truncateStoryblokRichText(text, charCount),
    [charCount, text],
  );

  return (
    <div className={classNames('w-full', className)}>
      {render(expanded ? text : truncatedText, {
        nodeResolvers: { paragraph },
        markResolvers: { link: RichTextLink },
      })}

      {!expanded ? (
        <button className="hyperlink" onClick={handleExpand} type="button">
          {t('readMore')}
        </button>
      ) : null}
    </div>
  );
};
